import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'react-loading-skeleton/dist/skeleton.css';
import PageLayout from '../../generic-components/PageLayout/PageLayout';
import { useTaxBucketTransactionsQuery } from '../../hooks/query/useTaxBucketTransactionsQuery';
import { TransactionTable } from '../../pages/TransactionsFacelift/components/TransactionTable';
import { useStore } from '../../store';
import { convertFilterToQueryString, getInitialTransactionsFilters } from '../transactions/utils';
import { TAX_BUCKET_TRANSACTIONS } from './constants';
import { TransactionDetailsDrawer } from '../../pages/TransactionsFacelift/components/TransactionDetailsDrawer';
import PageHeader from '../../generic-components/PageHeader/PageHeader';

const TaxBucketTransactions = () => {
  const { TAX_BUCKET_TRANSACTIONS_HEADER } = TAX_BUCKET_TRANSACTIONS;
  const { customerId } = useStore((state) => state.user);
  const selectedTransaction = useStore((state) => state.selectedTransaction);
  const [filterObject] = useState(getInitialTransactionsFilters());
  const initialQuery = convertFilterToQueryString(filterObject);
  const [query, setQuery] = useState<string>(initialQuery);
  const { refetch: refetchTransactions, isLoading } = useTaxBucketTransactionsQuery({ customerId, query });

  // Get transactions once query is updated
  useEffect(() => {
    refetchTransactions();
  }, [query]);

  // Once filter object changes we need to create a new query param
  useEffect(() => {
    if (!filterObject) return;
    setQuery(convertFilterToQueryString(filterObject));
  }, [filterObject]);

  const { t } = useTranslation();

  return (
    <PageLayout>
      <PageHeader title={t(TAX_BUCKET_TRANSACTIONS_HEADER)} pathToNavigate='/tax-bucket-dashboard/:main' />
      <div className='w-full h-[80dvh] flex flex-col relative'>
        <TransactionTable shouldLockScroll={false} isLoading={isLoading} disableGrouping />
      </div>
      {selectedTransaction && <TransactionDetailsDrawer />}
    </PageLayout>
  );
};

export default TaxBucketTransactions;
